/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactNode, useContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';

import EmployeeUtilizationContext from '@totem/components/ticketing/employeeUtilization/employeeUtilizationContext';
import {
  EmployeeUtilizationReportRequest,
  EmployeeUtilizationSummaryReport,
} from '@totem/components/ticketing/employeeUtilization/models';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull } from '@totem/utilities/common';
import { TICKETS_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  children?: ReactNode;
  startTime?: string;
  endTime?: string;
  departments?: string[];
  employees?: string[];
};
const EmployeeUtilizationContainer = ({
  children,
  startTime,
  endTime,
  departments,
  employees,
}: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [rawData, setRawData] =
    useState<EmployeeUtilizationSummaryReport>(null);
  const [holidays, setHolidays] = useState<string[]>([]);
  const [input, updateInput] = useState<EmployeeUtilizationReportRequest>({
    startTime: isNotNull(startTime)
      ? startTime
      : dayjs().startOf('week').toISOString(),
    endTime: isNotNull(endTime) ? endTime : dayjs().endOf('week').toISOString(),
    department: departments !== null ? departments : [],
    employee: employees !== null ? employees : [],
  });
  const [action, setAction] = useState<string>('');
  const [actionItem, setActionItem] = useState<string>('');
  const setInput = (updated: Partial<EmployeeUtilizationReportRequest>) => {
    updateInput({ ...input, ...updated });

    setRefreshData(true);
  };
  useEffect(() => {
    setInput({
      startTime: isNotNull(startTime)
        ? startTime
        : dayjs().startOf('week').toISOString(),
      endTime: isNotNull(endTime)
        ? endTime
        : dayjs().endOf('week').toISOString(),
      department: departments !== null ? departments : [],
      employee: employees !== null ? employees : [],
    });
  }, [startTime, endTime, employees, departments]);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);
      const params = input;
      setIsLoading(true);

      fetch(`${TICKETS_ENDPOINT}/utilization`, {
        method: 'POST',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
        body: JSON.stringify(params),
      })
        .then((res) => res.json())
        .then((result: EmployeeUtilizationSummaryReport) => {
          setRawData(result);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [refreshData, getApiToken]);
  const handleAction = (newActionItem: string, newAction: string) => {
    switch (action) {
      case 'refresh':
        setRefreshData(true);
        break;
      default:
        setAction(newAction);

        setActionItem(newActionItem);
    }
  };
  return (
    <EmployeeUtilizationContext.Provider
      value={{
        loading: isLoading,
        input,
        setInput,
        rawData,
        action,
        actionItem,
        onAction: handleAction,
        holidays,
      }}
    >
      {children}
    </EmployeeUtilizationContext.Provider>
  );
};
export default EmployeeUtilizationContainer;
